import React from "react";
import { Box, Typography, SxProps, Theme } from "@mui/material";
import { useBrandConfig } from "../queries/shared";
import backgroundImage from "../assets/images/BG4.png";

interface PromoImageProps {
  sx?: SxProps<Theme>;
  subtitle?: string;
}

interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
}

interface FeatureCardProps {
  features: Feature[];
}

export const PromoImage: React.FC<PromoImageProps> = ({
  sx,
  subtitle = "",
}) => {
  const { data: brandConfig } = useBrandConfig();

  const bannerImage = brandConfig?.brand?.bannerImage || backgroundImage;
  const bannerTitle = brandConfig?.brand?.bannerTitle || "";
  const bannerDescription = brandConfig?.brand?.bannerDescription || "";

  return (
    <Box
      sx={{
        borderRadius: 4,
        overflow: "hidden",
        textAlign: "center",
        position: "relative",
        color: "#fff",
        ...sx,
      }}
    >
      <img
        alt="promo-image"
        src={bannerImage}
        style={{
          width: "100%",
          height: "inherit",
          objectFit: "cover",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          p: 2,
          background:
            "linear-gradient(180deg, rgba(69, 86, 102, 0.0001) 10.54%, rgba(55, 69, 83, 0.392641) 35.78%, #212B36 94.68%)",
        }}
      >
        {(bannerTitle || subtitle) && (
          <Typography variant="h6" fontSize={44} lineHeight={1.3}>
            {bannerTitle}
            {bannerTitle && subtitle ? <br /> : null}
            {subtitle}
          </Typography>
        )}
        {bannerDescription && (
          <Typography
            variant="caption"
            display="block"
            fontSize={14}
            paddingBottom="25px"
          >
            {bannerDescription}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const FeatureCard: React.FC<FeatureCardProps> = ({ features }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gap: "30px",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "1fr",
          md: "repeat(2, 1fr)",
        },
      }}
    >
      {features.map((feature, index) => (
        <Box
          key={index}
          p="20px"
          border="1px solid #000"
          borderRadius="8px"
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
        >
          <Box mb="14px">{feature.icon}</Box>
          <Typography fontSize="18px" lineHeight={1.6} gutterBottom>
            {feature.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {feature.description}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default FeatureCard;
